import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import { mapState } from 'vuex'
import { router } from '@src/routes'
import { scrollToRouteHash } from '@shared/utils/scroll'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
    }
  },
  components: {
    'page-form-cmp': PageForm,
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  beforeRouteUpdate(to, from, next) {
    const path = to.path.replace(router.history.base, '')
    this.$root.setDataAnimateFalse()

    Vue.http.get(`templates${path}`, { params: to.query }).then(
      async data => {
        this.template = data.data

        await scrollToRouteHash(to.hash)

        next()
      },
      () => {
        next('/404')
      }
    )
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/events/view/index.js